import React from 'react';
import { Target, Upload, Plus, Eye, EyeOff, ArrowRight } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import DarkTooltip from '../ui/DarkTooltip';
import PageHeader from '../ui/PageHeader';

/**
 * NicheFinderHeader — replica o padrao da pagina Audio Generator:
 * PageHeader com `description` curto + `badge` de contagem total no
 * canto direito. Children sao os botoes de acao com altura padronizada
 * 36px pra alinhar com o badge.
 */
const NicheFinderHeader = ({
  stats,
  isSuperAdmin,
  isPrivacyMode,
  onTogglePrivacy,
  onOpenUpload,
  onOpenAdd,
}) => {
  const { t } = useTranslation();

  const total = stats?.total_active ?? stats?.filters?.all ?? 0;

  return (
    <PageHeader
      icon={<Target size={20} style={{ color: 'var(--dp-blue-500)' }} />}
      title={t('viralNiches.title')}
      description={t('viralNiches.subtitle')}
      titleBadge={t('viralNiches.subtitle_with_count', { total, week: stats?.weekly_new ?? 0 })}
    >
      {/* Privacy toggle (sempre disponivel) */}
      <DarkTooltip content={isPrivacyMode ? 'Disable privacy' : 'Enable privacy'}>
        <button
          type="button"
          onClick={onTogglePrivacy}
          aria-label={isPrivacyMode ? 'Disable privacy' : 'Enable privacy'}
          style={ACTION_BTN_STYLE_ICON}
        >
          {isPrivacyMode ? <EyeOff size={16} /> : <Eye size={16} />}
        </button>
      </DarkTooltip>

      {isSuperAdmin && (
        <>
          <button
            type="button"
            onClick={onOpenUpload}
            className="dp-btn-secondary"
            style={ACTION_BTN_STYLE}
          >
            <Upload size={14} />
            <span>{t('viralNiches.import_button')}</span>
          </button>
          <button
            type="button"
            onClick={onOpenAdd}
            className="dp-btn-cta dp-btn-cta--sm"
          >
            <Plus size={14} />
            <span>{t('viralNiches.add_channel_short')}</span>
            <ArrowRight size={14} />
          </button>
        </>
      )}
    </PageHeader>
  );
};

// Altura 36px alinha com o badge do PageHeader (`padding: 4px 12px` +
// `font-size: 11px` => ~24px de altura; aqui usamos 36px pra ficar
// proporcional aos botoes do padrao da app).
const ACTION_BTN_STYLE = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: 6,
  height: 36,
  padding: '0 14px',
  fontSize: 13,
  borderRadius: 12,
  fontFamily: 'var(--dp-font)',
};

const ACTION_BTN_STYLE_ICON = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: 36,
  height: 36,
  borderRadius: 8,
  background: 'transparent',
  border: '1px solid var(--dp-border-subtle)',
  color: 'var(--dp-text-secondary)',
  cursor: 'pointer',
};

export default NicheFinderHeader;
